<div class="fs-2 with-close" mat-dialog-title>
    <ng-container *ngIf="step !== 'rating'">Analyse IA</ng-container>
    <ng-container *ngIf="step === 'rating'">Donnez-nous votre avis</ng-container>
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>

<ng-template #modeTabs>
    <div class="mode-tabs">
        <div class="tabs tabs_full mt-0">
            <a class="tab" [class.active]="mode === 'ad'" (click)="selectMode('ad')">Annonce</a>
            <a class="tab" [class.active]="mode === 'dpe'" (click)="selectMode('dpe')">DPE</a>
        </div>
    </div>
</ng-template>

<!-- Step: Intro / Sélection objectif -->
<div mat-dialog-content *ngIf="step === 'intro'" class="intro-content">
    <ng-container *ngTemplateOutlet="modeTabs"></ng-container>

    <div class="info-box info-box-warning mb-3" *ngIf="blockedKind !== ''">
        <i class="fa fa-exclamation-triangle"></i>
        <span>
            {{ blockedMessage }}
            <ng-container *ngIf="blockedKind === 'credit' && aiCreditService.renewDate !== ''">
                Vos prochains crédits seront disponibles le {{ aiCreditService.renewDate | date:'dd/MM/yyyy' }}.
            </ng-container>
            <br/>
            <a [routerLink]="[aiCreditService.planUrl]" (click)="dialogRef.close(false)">
                <b *ngIf="blockedKind === 'credit'">Passer à un forfait supérieur</b>
                <b *ngIf="blockedKind === 'plan'">Voir les forfaits</b>
            </a>
        </span>
    </div>

    <ng-container *ngIf="mode === 'ad'">
        <p class="intro-text">
            Notre intelligence artificielle analyse votre projet immobilier en profondeur :
            points forts, points de vigilance et recommandations personnalisées.
        </p>
        <div class="info-box mb-3">
            <i class="fa fa-lightbulb-o"></i>
            <span>
                Vos notes sont transmises à l'IA pour enrichir l'analyse. N'hésitez pas à les compléter :
                posez des questions précises, ajoutez des détails, commentez la description,
                rédigez un rapport de prise d'info ou de visite, etc.
                Plus vos notes sont détaillées, plus l'analyse sera pertinente !
            </span>
        </div>
    </ng-container>

    <ng-container *ngIf="mode === 'dpe'">
        <p class="intro-text">
            Notre intelligence artificielle récupère le DPE officiel du bien et l'analyse :
            étiquettes énergie et climat, déperditions, travaux à prévoir, optimisations possibles,
            conseils et points à vérifier.
        </p>

        <app-ademe-input [(value)]="refAdeme" [readonly]="isShare">
            <div class="info-box info-box-warning mt-3 mb-0" *ngIf="isShare && !favorite.ref_ademe">
                <i class="fa fa-exclamation-triangle"></i>
                <span>
                    Le numéro ADEME n'a pas été renseigné sur cette annonce partagée.
                    L'analyse du DPE n'est pas disponible ici.
                </span>
            </div>
        </app-ademe-input>
    </ng-container>

    <ng-container *ngIf="mode === 'ad'">
        <b class="subtitle">Quel est l'objectif de votre projet ?</b>
        <div class="objective-grid">
            <div *ngFor="let obj of objectives"
                 class="objective-card"
                 [class.selected]="objective === obj.value"
                 (click)="selectObjective(obj.value)">
                <i class="fa {{ obj.icon }}"></i>
                <span>{{ obj.label }}</span>
            </div>
        </div>
    </ng-container>
    <p class="intro-text text-muted mt-3 mb-0">
        <i class="fa fa-info-circle me-1"></i>
        L'analyse prend environ 30 secondes et consomme 1 crédit IA.
    </p>
    <p class="intro-text text-muted mt-2 mb-0" *ngIf="blockedKind === ''">
        <i class="fa cfa cfa-star me-1"></i>
        Il vous reste <b>{{ aiCreditService.credit }}</b> crédit{{ aiCreditService.credit > 1 ? 's' : '' }} d'analyse IA<ng-container *ngIf="aiCreditService.renewDate !== ''">, prochaine recharge le {{ aiCreditService.renewDate | date:'dd/MM/yyyy' }}</ng-container>.
    </p>
</div>
<div mat-dialog-actions *ngIf="step === 'intro'">
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Fermer
    </button>
    <button (click)="analyze()" type="submit" class="btn btn-primary" [disabled]="!canAnalyze">
        Analyser
    </button>
</div>

<!-- Step: Enregistrement des modifications -->
<div mat-dialog-content *ngIf="step === 'saving'" class="loading-content">
    <div class="loading-container">
        <mat-spinner diameter="48"></mat-spinner>
        <p class="loading-text mt-3">Mise à jour du projet...</p>
        <p class="loading-subtext text-muted">Les modifications sélectionnées sont en cours d’enregistrement.</p>
    </div>
</div>

<!-- Step: Loading -->
<div mat-dialog-content *ngIf="step === 'loading'" class="loading-content">
    <div class="loading-container">
        <mat-spinner diameter="48"></mat-spinner>
        <p class="loading-text mt-3">Analyse en cours...</p>
        <p class="loading-subtext text-muted">
            <ng-container *ngIf="mode === 'ad'">Notre IA examine votre projet en détail.</ng-container>
            <ng-container *ngIf="mode === 'dpe'">Notre IA récupère et examine le DPE du bien.</ng-container><br/>
            Cela peut prendre jusqu'à une minute, merci de patienter.
        </p>
    </div>
</div>

<!-- Step: Résultat -->
<div mat-dialog-content *ngIf="step === 'result'" class="result-content">
    <ng-container *ngTemplateOutlet="modeTabs"></ng-container>
    <div class="result-meta mb-2" *ngIf="cachedAnalysis">
        <span class="text-muted fs-small" *ngIf="mode === 'ad'">
            Analyse pour : <b>{{ getObjectiveLabel(cachedAnalysis.objective) }}</b>
            — {{ cachedAnalysis.date | date:'dd/MM/yyyy à HH:mm' }}
        </span>
        <span class="text-muted fs-small" *ngIf="mode === 'dpe'">
            Analyse du DPE — {{ cachedAnalysis.date | date:'dd/MM/yyyy à HH:mm' }}
        </span>
        <button (click)="askRating()" type="button" class="btn btn-outline btn-sm">
            <i class="fa cfa cfa-star" aria-hidden="true"></i> Noter l'analyse
        </button>
    </div>
    <app-ai-result [result]="resultHtml">
        <section class="suggestions" *ngIf="hasSuggestions">
            <button type="button" class="suggestions-toggle" (click)="toggleSuggestions()" [attr.aria-expanded]="suggestionsExpanded">
                <span>
                    <i class="fa fa-exclamation-circle"></i>
                    Notre analyse a détecté {{ suggestions.length }} incohérence{{ suggestions.length > 1 ? 's' : '' }} dans les chiffres et suggère des modifications.
                </span>
                <span class="suggestions-toggle-action">
                    {{ suggestionsExpanded ? 'Masquer' : 'Afficher' }}
                    <i class="fa" [ngClass]="suggestionsExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </span>
            </button>

            <div class="suggestions-panel" *ngIf="suggestionsExpanded">
                <p class="text-muted">Choisissez les données à mettre à jour dans votre projet.</p>
                <div class="filter-popup-check suggestions-list">
                    <div class="filter-check-item suggestion" *ngFor="let suggestion of suggestions">
                        <div class="suggestion-field">
                            <mat-checkbox [checked]="suggestion.selected" [disabled]="isShare"
                                          (change)="suggestion.selected = $event.checked">
                                {{ suggestion.libelle || suggestion.champ }}
                            </mat-checkbox>
                            <ng-container *ngIf="suggestion.champ !== 'split_lot'; else splitLotSuggestion">
                                <select *ngIf="getSuggestionSelectOptions(suggestion.champ) as options; else suggestionInput"
                                        class="form-select suggestion-control" [(ngModel)]="suggestion.valeur" [disabled]="isShare">
                                    <option *ngFor="let option of options" [ngValue]="option.value">{{ option.label }}</option>
                                </select>
                                <ng-template #suggestionInput>
                                    <input class="form-control suggestion-control" [type]="getSuggestionInputType(suggestion.valeur)"
                                           [(ngModel)]="suggestion.valeur" [disabled]="isShare"/>
                                </ng-template>
                            </ng-container>
                            <ng-template #splitLotSuggestion>
                                <span class="suggestion-action">Séparer les lots</span>
                            </ng-template>
                        </div>
                        <span class="suggestion-reason" *ngIf="suggestion.raison">{{ suggestion.raison }}</span>
                    </div>
                </div>
                <p class="text-muted fs-small mb-0" *ngIf="isShare">
                    Les suggestions sont consultables, mais ne peuvent pas être appliquées à une annonce partagée.
                </p>
                <div class="suggestions-actions" *ngIf="!isShare">
                    <span>{{ selectedSuggestionsCount }} sélectionnée{{ selectedSuggestionsCount > 1 ? 's' : '' }}</span>
                    <div>
                        <button (click)="ignoreSuggestions()" type="button" class="btn btn-outline">
                            <i class="fa fa-times" aria-hidden="true"></i> Ignorer
                        </button>
                        <button (click)="applySuggestions()" type="button" class="btn btn-outline" [disabled]="!canApplySuggestions">
                            <i class="fa fa-check" aria-hidden="true"></i> Appliquer
                        </button>
                        <button (click)="applySuggestions(true)" type="button" class="btn btn-primary" [disabled]="!canApplySuggestions">
                            <i class="fa fa-refresh" aria-hidden="true"></i> Appliquer et relancer
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </app-ai-result>
</div>
<div mat-dialog-actions *ngIf="step === 'result'">
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">Fermer</button>
    <button (click)="newAnalysis()" type="button" class="btn btn-primary"><i class="fa fa-refresh" aria-hidden="true"></i> Nouvelle analyse</button>
</div>

<!-- Step: Rating -->
<div mat-dialog-content *ngIf="step === 'rating'">
    <ng-container *ngIf="!ratingSubmitted">
        <p>Aidez-nous à améliorer l'analyse IA en nous donnant votre avis.</p>
        <div class="rating-block">
            <star-rating labelText="Qualité de l'analyse" size="large"
                         labelPosition="top" [step]="1" [numOfStars]="5"
                         (ratingChange)="onRatingChange($event)" [hoverEnabled]="true"
                         [showHalfStars]="true" [starType]="'svg'"
                         [rating]="0"></star-rating>
        </div>
        <div class="info-box info-box-warning mb-3" *ngIf="rating > 0 && rating <= 3">
            <i class="fa fa-commenting-o"></i>
            <span>
                Une mauvaise note sans explication ne nous permet pas de nous améliorer.
                N'hésitez pas à détailler ce qui ne vous a pas convenu ou ce que vous aimeriez voir amélioré,
                cela nous aide énormément !
            </span>
        </div>
        <div class="label-value">Commentaire</div>
        <textarea class="comment-text" [(ngModel)]="comment"
                  placeholder="Dites-nous ce que vous en pensez..."></textarea>
    </ng-container>
    <ng-container *ngIf="ratingSubmitted">
        <div class="text-center mt-4 mb-4">
            <i class="fa fa-check-circle-o rating-success"></i>
        </div>
        <p class="text-center"><b>Merci pour votre avis !</b></p>
        <p class="text-center">Vos retours nous aident à améliorer l'analyse IA.</p>
    </ng-container>
</div>
<div mat-dialog-actions *ngIf="step === 'rating'">
    <ng-container *ngIf="!ratingSubmitted">
        <button (click)="backToResult()" class="btn btn-outline">Retour</button>
        <button (click)="submitRating()" class="btn btn-primary" [disabled]="rating == 0">Envoyer</button>
    </ng-container>
    <ng-container *ngIf="ratingSubmitted">
        <button (click)="backToResult()" class="btn btn-primary center">Retour à l'analyse</button>
    </ng-container>
</div>
